import { ParticipationStatus } from '../../types/models';

import Button from 'components/buttons/Button';
import Tooltip from 'components/tooltip/Tooltip';

import { getNotEligibleTooltipText } from '../../helpers/eligibility-message.helper';

type ParticipationButtonProps = {
  participationStatus: ParticipationStatus;
  isRegistering: boolean;
  onClickRegister: () => void;
  registrationError: string | null;
  eligibilityReasons?: string[];
  hasWallet?: boolean;
};

export const ParticipationButton = ({
  participationStatus,
  isRegistering,
  onClickRegister,
  registrationError,
  eligibilityReasons,
  hasWallet = false,
}: ParticipationButtonProps) => {
  switch (participationStatus) {
    case 'register':
      const buttonText = isRegistering ? 'Connecting...' : hasWallet ? 'Register' : 'Connect wallet';
      return (
        <Button
          text={buttonText}
          size="medium"
          color="referral-cta"
          className="tw-w-[180px] tw-self-center tw-px-0"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case tw-font-semibold"
          onClick={onClickRegister}
          requireWeb3
          disabled={isRegistering}
        />
      );

    case 'awaiting_distribution':
      return (
        <Button
          text="Awaiting distribution"
          size="medium"
          color="referral-yellow"
          className="tw-px-[20px] tw-leading-none"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case tw-font-semibold"
          disableIconAnimation
          iconComponentRight={
            <Tooltip
              className="tw-cursor-help"
              wrapperClassName="tw-flex tw-items-center"
              contentClassName="tw-w-72 bp-md:tw-w-96"
              text="The competition has ended. Rewards will be distributed soon."
              position="right"
              iconClassName="tw-text-[#FFD600]"
              variant="glass"
              offset={40}
            />
          }
        />
      );

    case 'participating':
      return (
        <Button
          text="Participating"
          size="medium"
          color="referral-green"
          className="tw-px-[20px] tw-leading-none"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case tw-font-semibold"
        />
      );

    case 'reward_distributed':
      return (
        <Button
          text="Rewards Distributed"
          size="medium"
          color="referral-green"
          className="tw-px-[20px] tw-leading-none"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case tw-font-semibold"
        />
      );

    case 'not_eligible':
      return (
        <Button
          text="Not Eligible"
          size="medium"
          color="referral-red"
          className="tw-px-[20px] tw-leading-none"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case tw-font-semibold"
          disableIconAnimation
          iconComponentRight={
            <Tooltip
              className="tw-cursor-help"
              wrapperClassName="tw-flex tw-items-center"
              contentClassName="tw-w-72 bp-md:tw-w-96"
              text={getNotEligibleTooltipText(eligibilityReasons, registrationError)}
              position="right"
              iconClassName="tw-text-[#F83A56]"
              variant="glass"
              offset={40}
            />
          }
        />
      );

    default:
      return null;
  }
};
